import { render, staticRenderFns } from "./recommended-poster.vue?vue&type=template&id=61206e05&scoped=true&"
import script from "./recommended-poster.vue?vue&type=script&lang=js&"
export * from "./recommended-poster.vue?vue&type=script&lang=js&"
import style0 from "./recommended-poster.vue?vue&type=style&index=0&id=61206e05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61206e05",
  null
  
)

export default component.exports